import { render, staticRenderFns } from "./productZhenshiwuliao.vue?vue&type=template&id=812b1f86&scoped=true"
import script from "./productZhenshiwuliao.vue?vue&type=script&lang=js"
export * from "./productZhenshiwuliao.vue?vue&type=script&lang=js"
import style0 from "./productZhenshiwuliao.vue?vue&type=style&index=0&id=812b1f86&prod&scoped=true&lang=css"
import style1 from "./productZhenshiwuliao.vue?vue&type=style&index=1&id=812b1f86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812b1f86",
  null
  
)

export default component.exports